import React from 'react';
import { BaseDateInput } from 'src/components/enterprise/components/BaseDateInput/BaseDateInput';

export interface StartDateInputProps {
  disabled?: boolean;
  id: string;
  name: string;
}

export const StartDateInput: React.FC<StartDateInputProps> = ({
  disabled = false,
  id,
  name,
}) => {
  return (
    <BaseDateInput
      id={id}
      name={name}
      label="Start date"
      disabled={disabled}
      rules={{ required: 'Required' }}
      disabledDays={{
        before: new Date(),
      }}
    />
  );
};
